import dayjs from "dayjs";
import "dayjs/locale/de";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "../locales/en";
import de from "../locales/de";

const detectionOrder = ["navigator"];
try {
    window.localStorage.getItem("i18nextLng");
    detectionOrder.unshift("localStorage");
} catch { /* Storage may be disabled; use the browser language. */ }

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            de: { translation: de },
        },
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
        keySeparator: ".",
        returnEmptyString: false,
        detection: {
            order: detectionOrder,
            caches: ["localStorage"],
        },
    });

// One place for language-dependent globals: dayjs month names and the document language.
const applyLanguage = (language: string) => {
    const code = language.toLowerCase().startsWith("de") ? "de" : "en";
    dayjs.locale(code);
    document.documentElement.lang = code;
};
applyLanguage(i18n.language ?? "en");
i18n.on("initialized", () => applyLanguage(i18n.language));
i18n.on("languageChanged", applyLanguage);
